// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-suggestions-container {
  position: relative;
  width: 100%;
  padding-top: 10px;
}

.input-suggestions-label {
  display: block;
  margin-bottom: 2px;
  color: var(--color-grey000);
}

.required-star {
  color: var(--color-grey000);
  margin-left: 4px;
}

.input-suggestions-input {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.input-suggestions-input:hover,
.input-suggestions-input:focus {
  outline: 3px solid var(--color-primaryLight);
  outline-offset: -3px;
}

.input-suggestions-menu {
  position: absolute;
  width: 100%;
  max-height: 180px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ccc;
  border-top: none;
  z-index: 1000;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  margin-top: -1px;
  padding: 0;
  list-style: none;
}


.input-suggestions-option {
  padding: 10px;
  cursor: pointer;
  color: var(--color-grey900);
  ;
}

.input-suggestions-option:hover {
  background-color: #f2f2f2;
}`, "",{"version":3,"sources":["webpack://./src/components/core/input/InputFieldWithSuggestions.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;EAEE,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;;AAE7B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".input-suggestions-container {\n  position: relative;\n  width: 100%;\n  padding-top: 10px;\n}\n\n.input-suggestions-label {\n  display: block;\n  margin-bottom: 2px;\n  color: var(--color-grey000);\n}\n\n.required-star {\n  color: var(--color-grey000);\n  margin-left: 4px;\n}\n\n.input-suggestions-input {\n  width: 100%;\n  padding: 10px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n}\n\n.input-suggestions-input:hover,\n.input-suggestions-input:focus {\n  outline: 3px solid var(--color-primaryLight);\n  outline-offset: -3px;\n}\n\n.input-suggestions-menu {\n  position: absolute;\n  width: 100%;\n  max-height: 180px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-top: none;\n  z-index: 1000;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n  margin-top: -1px;\n  padding: 0;\n  list-style: none;\n}\n\n\n.input-suggestions-option {\n  padding: 10px;\n  cursor: pointer;\n  color: var(--color-grey900);\n  ;\n}\n\n.input-suggestions-option:hover {\n  background-color: #f2f2f2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
